// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   Typography,
//   Button,
//   Switch,
//   Card,
//   CardContent,
//   Snackbar,
//   Alert,
//   MenuItem,
//   IconButton,
//   FormControlLabel,
//   Chip,
//   Divider,
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";

// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import { useParams } from "react-router-dom";

// const days = [
//   "monday",
//   "tuesday",
//   "wednesday",
//   "thursday",
//   "friday",
//   "saturday",
//   "sunday",
// ];

// const services = ["pickup", "delivery", "dine_in"];

// const RiteClientDetails = ({ client }) => {
//   const token = getDecryptedAccessToken();
//   const { clientId } = useParams();

//   const resolvedClientId = clientId || client?.client_id;


//   const [profile, setProfile] = useState(null);
//   const [workingHours, setWorkingHours] = useState([]); // fetched flat list from GET
//   const [workingHoursForm, setWorkingHoursForm] = useState([]); // editable rows for POST payload
//   const [closures, setClosures] = useState([]);
//   const [serviceTypes, setServiceTypes] = useState({
//     pickup: false,
//     delivery: false,
//     dine_in: false,
//   });

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const today = new Date().toISOString().split("T")[0];

//   const showSnackbar = (msg, type = "success") => {
//     setSnackbar({ open: true, message: msg, severity: type });
//   };

//   // ========================= FETCH =========================
//   const fetchProfile = async () => {
//     try {
//       const res = await ApiServices.get(
//         `/api/v1/clients/${resolvedClientId}/full/`,
//         { Authorization: `Bearer ${token}` }
//       );

//       setProfile(res.data);
//       setClosures(res.data.service_closures || []);
//       setServiceTypes(
//         res.data.service_types || {
//           pickup: false,
//           delivery: false,
//           dine_in: false,
//         }
//       );
//     } catch {
//       showSnackbar("Failed loading client", "error");
//     }
//   };

//   const fetchWorkingHours = async () => {
//     try {
//       const res = await ApiServices.get(
//         `/api/v1/clients/${resolvedClientId}/working-hours/`,
//         { Authorization: `Bearer ${token}` }
//       );
//       setWorkingHours(Array.isArray(res.data) ? res.data : []);
//     } catch {
//       setWorkingHours([]);
//       showSnackbar("Failed loading working hours", "error");
//     }
//   };

//   const fetchAll = async () => {
//     await Promise.all([fetchProfile(), fetchWorkingHours()]);
//   };

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   // ========================= DETAILS =========================
//   const validateDetails = () => {
//     if (!profile.details?.trading_name?.trim()) return "Trading name required";
//     if (!profile.details?.year_established) return "Year required";

//     const year = Number(profile.details.year_established);
//     const currentYear = new Date().getFullYear();

//     if (Number.isNaN(year) || year < 1800 || year > currentYear) {
//       return "Enter a valid year established";
//     }

//     return null;
//   };

//   const saveDetails = async () => {
//     const error = validateDetails();
//     if (error) return showSnackbar(error, "error");

//     try {
//       await ApiServices.patch(
//         `/api/v1/clients/${resolvedClientId}/details/`,
//         profile.details,
//         { Authorization: `Bearer ${token}` }
//       );
//       showSnackbar("Details saved");
//       fetchProfile();
//     } catch {
//       showSnackbar("Error saving details", "error");
//     }
//   };

//   // ========================= SERVICE TYPES =========================
//   const saveServiceTypes = async () => {
//     try {
//       await ApiServices.post(
//         `/api/v1/clients/${resolvedClientId}/service-types/`,
//         serviceTypes,
//         { Authorization: `Bearer ${token}` }
//       );
//       showSnackbar("Service types updated");
//       fetchProfile();
//     } catch {
//       showSnackbar("Error updating service types", "error");
//     }
//   };

//   // ========================= WORKING HOURS =========================
//   const addWorkingHourRow = () => {
//     setWorkingHoursForm((prev) => [
//       ...prev,
//       {
//         local_id: Date.now() + Math.random(),
//         service_type: "",
//         day: "",
//         open_time: "",
//         close_time: "",
//         break_start: "",
//         break_end: "",
//       },
//     ]);
//   };

//   const updateWorkingHourRow = (index, field, value) => {
//     setWorkingHoursForm((prev) => {
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: value,
//       };
//       return updated;
//     });
//   };

//   const removeWorkingHourRow = (index) => {
//     setWorkingHoursForm((prev) => prev.filter((_, i) => i !== index));
//   };

//   const validateWorkingHours = () => {
//     if (!workingHoursForm.length) {
//       return "Add at least one working hours row";
//     }

//     for (let i = 0; i < workingHoursForm.length; i++) {
//       const row = workingHoursForm[i];
//       const rowNo = i + 1;

//       if (!row.service_type) return `Select service type for row ${rowNo}`;
//       if (!services.includes(row.service_type)) {
//         return `Invalid service type in row ${rowNo}`;
//       }

//       if (!row.day) return `Select day for row ${rowNo}`;
//       if (!days.includes(row.day)) {
//         return `Invalid day in row ${rowNo}`;
//       }

//       if (!row.open_time) return `Open time required in row ${rowNo}`;
//       if (!row.close_time) return `Close time required in row ${rowNo}`;

//       if (row.open_time >= row.close_time) {
//         return `Close time must be after open time in row ${rowNo}`;
//       }

//       if (row.break_start && !row.break_end) {
//         return `Break end required in row ${rowNo}`;
//       }

//       if (!row.break_start && row.break_end) {
//         return `Break start required in row ${rowNo}`;
//       }

//       if (row.break_start && row.break_end) {
//         if (!(row.break_start > row.open_time && row.break_end < row.close_time)) {
//           return `Break time must be within open and close time in row ${rowNo}`;
//         }
//         if (row.break_start >= row.break_end) {
//           return `Break end must be after break start in row ${rowNo}`;
//         }
//       }
//     }

//     return null;
//   };

//   const buildWorkingHoursPayload = () => {
//     const grouped = {};

//     workingHoursForm.forEach((row) => {
//       if (!grouped[row.service_type]) {
//         grouped[row.service_type] = [];
//       }

//       grouped[row.service_type].push({
//         day: row.day,
//         open_time: row.open_time,
//         close_time: row.close_time,
//         ...(row.break_start ? { break_start: row.break_start } : {}),
//         ...(row.break_end ? { break_end: row.break_end } : {}),
//       });
//     });

//     return {
//       working_hours: Object.keys(grouped).map((serviceType) => ({
//         service_type: serviceType,
//         schedule: grouped[serviceType],
//       })),
//     };
//   };

//   const saveWorkingHours = async () => {
//     const error = validateWorkingHours();
//     if (error) return showSnackbar(error, "error");

//     try {
//       const payload = buildWorkingHoursPayload();

//       await ApiServices.post(
//         `/api/v1/clients/${resolvedClientId}/working-hours/`,
//         payload,
//         { Authorization: `Bearer ${token}` }
//       );

//       showSnackbar("Working hours saved");
//       setWorkingHoursForm([]);
//       fetchWorkingHours();
//     } catch {
//       showSnackbar("Error saving working hours", "error");
//     }
//   };

//   // ========================= CLOSURES =========================
//   const addClosureRow = () => {
//     setClosures((prev) => [
//       ...prev,
//       {
//         local_id: Date.now() + Math.random(),
//         id: null,
//         service_types: ["all"],
//         start_date: today,
//         end_date: today,
//         reason: "",
//         isNew: true,
//       },
//     ]);
//   };

//   const updateClosureField = (index, field, value) => {
//     setClosures((prev) => {
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: value,
//       };
//       return updated;
//     });
//   };

//   const handleClosureServiceTypeToggle = (index, value) => {
//     setClosures((prev) => {
//       const updated = [...prev];
//       const current = updated[index];
//       let currentTypes = Array.isArray(current.service_types)
//         ? [...current.service_types]
//         : [];

//       if (value === "all") {
//         currentTypes = ["all"];
//       } else {
//         currentTypes = currentTypes.filter((item) => item !== "all");

//         if (currentTypes.includes(value)) {
//           currentTypes = currentTypes.filter((item) => item !== value);
//         } else {
//           currentTypes.push(value);
//         }

//         if (!currentTypes.length) {
//           currentTypes = ["all"];
//         }
//       }

//       updated[index] = {
//         ...current,
//         service_types: currentTypes,
//       };

//       return updated;
//     });
//   };

//   const validateClosure = (closure) => {
//     if (!closure.start_date) return "Closure start date required";
//     if (!closure.end_date) return "Closure end date required";
//     if (closure.end_date < closure.start_date) {
//       return "Closure end date cannot be before start date";
//     }
//     if (
//       !Array.isArray(closure.service_types) ||
//       closure.service_types.length === 0
//     ) {
//       return "Select at least one closure service type";
//     }
//     return null;
//   };

//   const saveClosure = async (closure) => {
//     const error = validateClosure(closure);
//     if (error) return showSnackbar(error, "error");

//     const payload = {
//       service_types: closure.service_types,
//       start_date: closure.start_date,
//       end_date: closure.end_date,
//       reason: closure.reason || "",
//     };

//     try {
//       if (closure.id) {
//         await ApiServices.patch(
//           `/api/v1/clients/service-close/${closure.id}/`,
//           payload,
//           {
//             Authorization: `Bearer ${token}`,
//           }
//         );
//         showSnackbar("Closure updated");
//       } else {
//         await ApiServices.post(
//           `/api/v1/clients/${resolvedClientId}/service-close/`,
//           payload,
//           {
//             Authorization: `Bearer ${token}`,
//           }
//         );
//         showSnackbar("Closure created");
//       }

//       fetchProfile();
//     } catch {
//       showSnackbar("Error saving closure", "error");
//     }
//   };

//   const deleteClosure = async (closure, index) => {
//     try {
//       if (!closure.id) {
//         setClosures((prev) => prev.filter((_, i) => i !== index));
//         return;
//       }

//       await ApiServices.delete(`/api/v1/clients/service-close/${closure.id}/`, {
//         Authorization: `Bearer ${token}`,
//       });

//       showSnackbar("Closure deleted");
//       fetchProfile();
//     } catch {
//       showSnackbar("Error deleting closure", "error");
//     }
//   };

//   if (!profile) return null;

//   return (
//     <Box>
//       {/* DETAILS */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6">Client Details</Typography>

//           <Grid container spacing={2} mt={1}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Trading Name"
//                 fullWidth
//                 value={profile.details?.trading_name || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: {
//                       ...profile.details,
//                       trading_name: e.target.value,
//                     },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Tagline"
//                 fullWidth
//                 value={profile.details?.tagline || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, tagline: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="About"
//                 multiline
//                 rows={3}
//                 fullWidth
//                 value={profile.details?.about_us || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, about_us: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 label="Year"
//                 type="number"
//                 fullWidth
//                 value={profile.details?.year_established || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: {
//                       ...profile.details,
//                       year_established: e.target.value,
//                     },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 label="Category ID"
//                 fullWidth
//                 value={profile.details?.category_id || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, category_id: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Button variant="contained" onClick={saveDetails}>
//                 Save Details
//               </Button>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>

//       {/* SERVICE TYPES */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6">Service Types</Typography>

//           <Box mt={1}>
//             {services.map((s) => (
//               <FormControlLabel
//                 key={s}
//                 control={
//                   <Switch
//                     checked={!!serviceTypes[s]}
//                     onChange={(e) =>
//                       setServiceTypes({
//                         ...serviceTypes,
//                         [s]: e.target.checked,
//                       })
//                     }
//                   />
//                 }
//                 label={s}
//               />
//             ))}
//           </Box>

//           <Box mt={2}>
//             <Button variant="contained" onClick={saveServiceTypes}>
//               Save Services
//             </Button>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* WORKING HOURS */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom>
//             Working Hours
//           </Typography>

//           <Typography variant="body2" sx={{ mb: 2 }}>
//             Add one or more rows. These will be grouped automatically by service
//             type and sent in the required bulk upsert payload.
//           </Typography>

//           <Button variant="outlined" sx={{ mb: 2 }} onClick={addWorkingHourRow}>
//             Add Working Hour Row
//           </Button>

//           {workingHoursForm.map((row, index) => (
//             <Card key={row.local_id} sx={{ p: 2, mb: 2, background: "#fafafa" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     select
//                     label="Service Type"
//                     fullWidth
//                     value={row.service_type}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "service_type", e.target.value)
//                     }
//                   >
//                     {services.map((s) => (
//                       <MenuItem key={s} value={s}>
//                         {s}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     select
//                     label="Day"
//                     fullWidth
//                     value={row.day}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "day", e.target.value)
//                     }
//                   >
//                     {days.map((day) => (
//                       <MenuItem key={day} value={day}>
//                         {day}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Open Time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.open_time}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "open_time", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Close Time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.close_time}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "close_time", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Break Start"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.break_start}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "break_start", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={1.5}>
//                   <TextField
//                     type="time"
//                     label="Break End"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.break_end}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "break_end", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={0.5}>
//                   <IconButton
//                     color="error"
//                     sx={{ mt: { xs: 0, md: 1 } }}
//                     onClick={() => removeWorkingHourRow(index)}
//                   >
//                     <DeleteIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Card>
//           ))}

//           <Box mt={2}>
//             <Button variant="contained" onClick={saveWorkingHours}>
//               Save Working Hours
//             </Button>
//           </Box>

//           <Divider sx={{ my: 3 }} />

//           <Typography variant="subtitle1" gutterBottom>
//             Existing Working Hours
//           </Typography>

//           {!workingHours.length ? (
//             <Typography variant="body2">No working hours found.</Typography>
//           ) : (
//             <Grid container spacing={2}>
//               {workingHours.map((item) => (
//                 <Grid item xs={12} md={6} key={item.id}>
//                   <Card sx={{ p: 2, height: "100%" }}>
//                     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                       {item.service_type}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Day:</strong> {item.day}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Open:</strong> {item.open_time}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Close:</strong> {item.close_time}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Break Start:</strong>{" "}
//                       {item.break_start || "-"}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Break End:</strong> {item.break_end || "-"}
//                     </Typography>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           )}
//         </CardContent>
//       </Card>

//       {/* CLOSURES */}
//       <Card>
//         <CardContent>
//           <Typography variant="h6" gutterBottom>
//             Closures
//           </Typography>

//           <Button variant="outlined" sx={{ mb: 2 }} onClick={addClosureRow}>
//             Add Closure
//           </Button>

//           {!closures.length ? (
//             <Typography variant="body2">No closures added.</Typography>
//           ) : null}

//           {closures.map((c, index) => (
//             <Card key={c.id || c.local_id} sx={{ mb: 2, p: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                     Service Types
//                   </Typography>

//                   <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                     <Chip
//                       label="all"
//                       color={
//                         c.service_types?.includes("all") ? "primary" : "default"
//                       }
//                       onClick={() =>
//                         handleClosureServiceTypeToggle(index, "all")
//                       }
//                     />
//                     {services.map((service) => (
//                       <Chip
//                         key={service}
//                         label={service}
//                         color={
//                           c.service_types?.includes(service)
//                             ? "primary"
//                             : "default"
//                         }
//                         onClick={() =>
//                           handleClosureServiceTypeToggle(index, service)
//                         }
//                       />
//                     ))}
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     type="date"
//                     label="Start Date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={c.start_date || ""}
//                     onChange={(e) =>
//                       updateClosureField(index, "start_date", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     type="date"
//                     label="End Date"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={c.end_date || ""}
//                     onChange={(e) =>
//                       updateClosureField(index, "end_date", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     label="Reason"
//                     fullWidth
//                     value={c.reason || ""}
//                     onChange={(e) =>
//                       updateClosureField(index, "reason", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid
//                   item
//                   xs={12}
//                   md={2}
//                   sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                 >
//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={() => saveClosure(c)}
//                   >
//                     Save
//                   </Button>

//                   <IconButton
//                     color="error"
//                     onClick={() => deleteClosure(c, index)}
//                   >
//                     <DeleteIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Card>
//           ))}
//         </CardContent>
//       </Card>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert
//           severity={snackbar.severity}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default RiteClientDetails;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   Typography,
//   Button,
//   Switch,
//   Card,
//   CardContent,
//   Snackbar,
//   Alert,
//   MenuItem,
//   IconButton,
//   FormControlLabel,
//   Chip,
//   Divider,
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";

// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import { useParams } from "react-router-dom";

// const days = [
//   "monday",
//   "tuesday",
//   "wednesday",
//   "thursday",
//   "friday",
//   "saturday",
//   "sunday",
// ];

// const services = ["pickup", "delivery", "dine_in"];

// const RiteClientDetails = ({ client }) => {
//   const token = getDecryptedAccessToken();
//   const { clientId } = useParams();

//   const resolvedClientId = clientId || client?.client_id;

//   const [profile, setProfile] = useState(null);
//   const [workingHours, setWorkingHours] = useState([]);
//   const [workingHoursForm, setWorkingHoursForm] = useState([]);
//   const [closures, setClosures] = useState([]);
//   const [serviceTypes, setServiceTypes] = useState({
//     pickup: false,
//     delivery: false,
//     dine_in: false,
//   });

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const today = new Date().toISOString().split("T")[0];

//   const showSnackbar = (msg, type = "success") => {
//     setSnackbar({ open: true, message: msg, severity: type });
//   };

//   // ========================= FETCH =========================
//   const fetchProfile = async () => {
//     try {
//       const res = await ApiServices.get(
//         `/api/v1/clients/${resolvedClientId}/full/`,
//         { Authorization: `Bearer ${token}` }
//       );

//       setProfile(res.data);
//       setServiceTypes(
//         res.data.service_types || {
//           pickup: false,
//           delivery: false,
//           dine_in: false,
//         }
//       );
//     } catch {
//       showSnackbar("Failed loading client", "error");
//     }
//   };

//   const fetchWorkingHours = async () => {
//     try {
//       const res = await ApiServices.get(
//         `/api/v1/clients/${resolvedClientId}/working-hours/`,
//         { Authorization: `Bearer ${token}` }
//       );
//       setWorkingHours(Array.isArray(res.data) ? res.data : []);
//     } catch {
//       setWorkingHours([]);
//       showSnackbar("Failed loading working hours", "error");
//     }
//   };

//   const fetchClosures = async () => {
//     try {
//       const res = await ApiServices.get(
//         `/api/v1/clients/${resolvedClientId}/service-close/`,
//         { Authorization: `Bearer ${token}` }
//       );

//       const closureList = Array.isArray(res.data) ? res.data : [];

//       setClosures(
//         closureList.map((item) => ({
//           ...item,
//           local_id: item.id || Date.now() + Math.random(),
//           isNew: false,
//         }))
//       );
//     } catch {
//       setClosures([]);
//       showSnackbar("Failed loading closures", "error");
//     }
//   };

//   const fetchAll = async () => {
//     await Promise.all([fetchProfile(), fetchWorkingHours(), fetchClosures()]);
//   };

//   useEffect(() => {
//     if (resolvedClientId) {
//       fetchAll();
//     }
//   }, [resolvedClientId]);

//   // ========================= DETAILS =========================
//   const validateDetails = () => {
//     if (!profile.details?.trading_name?.trim()) return "Trading name required";
//     if (!profile.details?.year_established) return "Year required";

//     const year = Number(profile.details.year_established);
//     const currentYear = new Date().getFullYear();

//     if (Number.isNaN(year) || year < 1800 || year > currentYear) {
//       return "Enter a valid year established";
//     }

//     return null;
//   };

//   const saveDetails = async () => {
//     const error = validateDetails();
//     if (error) return showSnackbar(error, "error");

//     try {
//       await ApiServices.patch(
//         `/api/v1/clients/${resolvedClientId}/details/`,
//         profile.details,
//         { Authorization: `Bearer ${token}` }
//       );
//       showSnackbar("Details saved");
//       fetchProfile();
//     } catch {
//       showSnackbar("Error saving details", "error");
//     }
//   };

//   // ========================= SERVICE TYPES =========================
//   const saveServiceTypes = async () => {
//     try {
//       await ApiServices.post(
//         `/api/v1/clients/${resolvedClientId}/service-types/`,
//         serviceTypes,
//         { Authorization: `Bearer ${token}` }
//       );
//       showSnackbar("Service types updated");
//       fetchProfile();
//     } catch {
//       showSnackbar("Error updating service types", "error");
//     }
//   };

//   // ========================= WORKING HOURS =========================
//   const addWorkingHourRow = () => {
//     setWorkingHoursForm((prev) => [
//       ...prev,
//       {
//         local_id: Date.now() + Math.random(),
//         service_type: "",
//         day: "",
//         open_time: "",
//         close_time: "",
//         break_start: "",
//         break_end: "",
//       },
//     ]);
//   };

//   const updateWorkingHourRow = (index, field, value) => {
//     setWorkingHoursForm((prev) => {
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: value,
//       };
//       return updated;
//     });
//   };

//   const removeWorkingHourRow = (index) => {
//     setWorkingHoursForm((prev) => prev.filter((_, i) => i !== index));
//   };

//   const validateWorkingHours = () => {
//     if (!workingHoursForm.length) {
//       return "Add at least one working hours row";
//     }

//     for (let i = 0; i < workingHoursForm.length; i++) {
//       const row = workingHoursForm[i];
//       const rowNo = i + 1;

//       if (!row.service_type) return `Select service type for row ${rowNo}`;
//       if (!services.includes(row.service_type)) {
//         return `Invalid service type in row ${rowNo}`;
//       }

//       if (!row.day) return `Select day for row ${rowNo}`;
//       if (!days.includes(row.day)) {
//         return `Invalid day in row ${rowNo}`;
//       }

//       if (!row.open_time) return `Open time required in row ${rowNo}`;
//       if (!row.close_time) return `Close time required in row ${rowNo}`;

//       if (row.open_time >= row.close_time) {
//         return `Close time must be after open time in row ${rowNo}`;
//       }

//       if (row.break_start && !row.break_end) {
//         return `Break end required in row ${rowNo}`;
//       }

//       if (!row.break_start && row.break_end) {
//         return `Break start required in row ${rowNo}`;
//       }

//       if (row.break_start && row.break_end) {
//         if (!(row.break_start > row.open_time && row.break_end < row.close_time)) {
//           return `Break time must be within open and close time in row ${rowNo}`;
//         }
//         if (row.break_start >= row.break_end) {
//           return `Break end must be after break start in row ${rowNo}`;
//         }
//       }
//     }

//     return null;
//   };

//   const buildWorkingHoursPayload = () => {
//     const grouped = {};

//     workingHoursForm.forEach((row) => {
//       if (!grouped[row.service_type]) {
//         grouped[row.service_type] = [];
//       }

//       grouped[row.service_type].push({
//         day: row.day,
//         open_time: row.open_time,
//         close_time: row.close_time,
//         ...(row.break_start ? { break_start: row.break_start } : {}),
//         ...(row.break_end ? { break_end: row.break_end } : {}),
//       });
//     });

//     return {
//       working_hours: Object.keys(grouped).map((serviceType) => ({
//         service_type: serviceType,
//         schedule: grouped[serviceType],
//       })),
//     };
//   };

//   const saveWorkingHours = async () => {
//     const error = validateWorkingHours();
//     if (error) return showSnackbar(error, "error");

//     try {
//       const payload = buildWorkingHoursPayload();

//       await ApiServices.post(
//         `/api/v1/clients/${resolvedClientId}/working-hours/`,
//         payload,
//         { Authorization: `Bearer ${token}` }
//       );

//       showSnackbar("Working hours saved");
//       setWorkingHoursForm([]);
//       fetchWorkingHours();
//     } catch {
//       showSnackbar("Error saving working hours", "error");
//     }
//   };

//   // ========================= CLOSURES =========================
//   const addClosureRow = () => {
//     setClosures((prev) => [
//       {
//         local_id: Date.now() + Math.random(),
//         id: null,
//         service_types: ["all"],
//         start_date: today,
//         end_date: today,
//         reason: "",
//         isNew: true,
//       },
//       ...prev,
//     ]);
//   };

//   const updateClosureField = (index, field, value) => {
//     setClosures((prev) => {
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: value,
//       };
//       return updated;
//     });
//   };

//   const handleClosureServiceTypeToggle = (index, value) => {
//     setClosures((prev) => {
//       const updated = [...prev];
//       const current = updated[index];
//       let currentTypes = Array.isArray(current.service_types)
//         ? [...current.service_types]
//         : [];

//       if (value === "all") {
//         currentTypes = ["all"];
//       } else {
//         currentTypes = currentTypes.filter((item) => item !== "all");

//         if (currentTypes.includes(value)) {
//           currentTypes = currentTypes.filter((item) => item !== value);
//         } else {
//           currentTypes.push(value);
//         }

//         if (!currentTypes.length) {
//           currentTypes = ["all"];
//         }
//       }

//       updated[index] = {
//         ...current,
//         service_types: currentTypes,
//       };

//       return updated;
//     });
//   };

//   const validateClosure = (closure) => {
//     if (!closure.start_date) return "Closure start date required";
//     if (!closure.end_date) return "Closure end date required";
//     if (closure.end_date < closure.start_date) {
//       return "Closure end date cannot be before start date";
//     }
//     if (
//       !Array.isArray(closure.service_types) ||
//       closure.service_types.length === 0
//     ) {
//       return "Select at least one closure service type";
//     }
//     return null;
//   };

//   const saveClosure = async (closure) => {
//     const error = validateClosure(closure);
//     if (error) return showSnackbar(error, "error");

//     const payload = {
//       service_types: closure.service_types,
//       start_date: closure.start_date,
//       end_date: closure.end_date,
//       reason: closure.reason || "",
//     };

//     try {
//       if (closure.id) {
//         await ApiServices.patch(
//           `/api/v1/clients/service-close/${closure.id}/`,
//           payload,
//           {
//             Authorization: `Bearer ${token}`,
//           }
//         );
//         showSnackbar("Closure updated");
//       } else {
//         await ApiServices.post(
//           `/api/v1/clients/${resolvedClientId}/service-close/`,
//           payload,
//           {
//             Authorization: `Bearer ${token}`,
//           }
//         );
//         showSnackbar("Closure created");
//       }

//       fetchClosures();
//     } catch {
//       showSnackbar("Error saving closure", "error");
//     }
//   };

//   const deleteClosure = async (closure, index) => {
//     try {
//       if (!closure.id) {
//         setClosures((prev) => prev.filter((_, i) => i !== index));
//         showSnackbar("Unsaved closure removed");
//         return;
//       }

//       await ApiServices.delete(`/api/v1/clients/service-close/${closure.id}/`, {
//         Authorization: `Bearer ${token}`,
//       });

//       showSnackbar("Closure deleted");
//       fetchClosures();
//     } catch {
//       showSnackbar("Error deleting closure", "error");
//     }
//   };

//   if (!profile) return null;

//   return (
//     <Box>
//       {/* DETAILS */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6">Client Details</Typography>

//           <Grid container spacing={2} mt={1}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Trading Name"
//                 fullWidth
//                 value={profile.details?.trading_name || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: {
//                       ...profile.details,
//                       trading_name: e.target.value,
//                     },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Tagline"
//                 fullWidth
//                 value={profile.details?.tagline || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, tagline: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="About"
//                 multiline
//                 rows={3}
//                 fullWidth
//                 value={profile.details?.about_us || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, about_us: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 label="Year"
//                 type="number"
//                 fullWidth
//                 value={profile.details?.year_established || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: {
//                       ...profile.details,
//                       year_established: e.target.value,
//                     },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextField
//                 label="Category ID"
//                 fullWidth
//                 value={profile.details?.category_id || ""}
//                 onChange={(e) =>
//                   setProfile({
//                     ...profile,
//                     details: { ...profile.details, category_id: e.target.value },
//                   })
//                 }
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Button variant="contained" onClick={saveDetails}>
//                 Save Details
//               </Button>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>

//       {/* SERVICE TYPES */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6">Service Types</Typography>

//           <Box mt={1}>
//             {services.map((s) => (
//               <FormControlLabel
//                 key={s}
//                 control={
//                   <Switch
//                     checked={!!serviceTypes[s]}
//                     onChange={(e) =>
//                       setServiceTypes({
//                         ...serviceTypes,
//                         [s]: e.target.checked,
//                       })
//                     }
//                   />
//                 }
//                 label={s}
//               />
//             ))}
//           </Box>

//           <Box mt={2}>
//             <Button variant="contained" onClick={saveServiceTypes}>
//               Save Services
//             </Button>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* WORKING HOURS */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6" gutterBottom>
//             Working Hours
//           </Typography>

//           <Typography variant="body2" sx={{ mb: 2 }}>
//             Add one or more rows. These will be grouped automatically by service
//             type and sent in the required bulk upsert payload.
//           </Typography>

//           <Button variant="outlined" sx={{ mb: 2 }} onClick={addWorkingHourRow}>
//             Add Working Hour Row
//           </Button>

//           {workingHoursForm.map((row, index) => (
//             <Card key={row.local_id} sx={{ p: 2, mb: 2, background: "#fafafa" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     select
//                     label="Service Type"
//                     fullWidth
//                     value={row.service_type}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "service_type", e.target.value)
//                     }
//                   >
//                     {services.map((s) => (
//                       <MenuItem key={s} value={s}>
//                         {s}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     select
//                     label="Day"
//                     fullWidth
//                     value={row.day}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "day", e.target.value)
//                     }
//                   >
//                     {days.map((day) => (
//                       <MenuItem key={day} value={day}>
//                         {day}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Open Time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.open_time}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "open_time", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Close Time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.close_time}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "close_time", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={2}>
//                   <TextField
//                     type="time"
//                     label="Break Start"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.break_start}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "break_start", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={1.5}>
//                   <TextField
//                     type="time"
//                     label="Break End"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={row.break_end}
//                     onChange={(e) =>
//                       updateWorkingHourRow(index, "break_end", e.target.value)
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={0.5}>
//                   <IconButton
//                     color="error"
//                     sx={{ mt: { xs: 0, md: 1 } }}
//                     onClick={() => removeWorkingHourRow(index)}
//                   >
//                     <DeleteIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Card>
//           ))}

//           <Box mt={2}>
//             <Button variant="contained" onClick={saveWorkingHours}>
//               Save Working Hours
//             </Button>
//           </Box>

//           <Divider sx={{ my: 3 }} />

//           <Typography variant="subtitle1" gutterBottom>
//             Existing Working Hours
//           </Typography>

//           {!workingHours.length ? (
//             <Typography variant="body2">No working hours found.</Typography>
//           ) : (
//             <Grid container spacing={2}>
//               {workingHours.map((item) => (
//                 <Grid item xs={12} md={6} key={item.id}>
//                   <Card sx={{ p: 2, height: "100%" }}>
//                     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                       {item.service_type}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Day:</strong> {item.day}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Open:</strong> {item.open_time}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Close:</strong> {item.close_time}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Break Start:</strong> {item.break_start || "-"}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Break End:</strong> {item.break_end || "-"}
//                     </Typography>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           )}
//         </CardContent>
//       </Card>

//       {/* CLOSURES */}
//       <Card>
//         <CardContent>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2,
//               flexWrap: "wrap",
//               gap: 1,
//             }}
//           >
//             <Typography variant="h6">Service Closures</Typography>

//             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//               <Button variant="outlined" onClick={addClosureRow}>
//                 Add Closure
//               </Button>
//               <Button variant="text" onClick={fetchClosures}>
//                 Refresh Closures
//               </Button>
//             </Box>
//           </Box>

//           {!closures.length ? (
//             <Typography variant="body2">No closures available.</Typography>
//           ) : (
//             <>
//               <Typography variant="subtitle1" gutterBottom>
//                 Available Closures
//               </Typography>

//               {closures.map((c, index) => (
//                 <Card
//                   key={c.id || c.local_id}
//                   sx={{
//                     mb: 2,
//                     p: 2,
//                     border: c.isNew ? "1px dashed #1976d2" : "1px solid #e0e0e0",
//                     backgroundColor: c.isNew ? "#f8fbff" : "#fff",
//                   }}
//                 >
//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           flexWrap: "wrap",
//                           gap: 1,
//                         }}
//                       >
//                         <Typography variant="subtitle2">
//                           {c.id ? `Closure #${c.id}` : "New Closure"}
//                         </Typography>

//                         <Typography variant="body2" color="text.secondary">
//                           {c.start_date || "-"} to {c.end_date || "-"}
//                         </Typography>
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                         Service Types
//                       </Typography>

//                       <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//                         <Chip
//                           label="all"
//                           color={c.service_types?.includes("all") ? "primary" : "default"}
//                           onClick={() => handleClosureServiceTypeToggle(index, "all")}
//                         />
//                         {services.map((service) => (
//                           <Chip
//                             key={service}
//                             label={service}
//                             color={
//                               c.service_types?.includes(service) ? "primary" : "default"
//                             }
//                             onClick={() =>
//                               handleClosureServiceTypeToggle(index, service)
//                             }
//                           />
//                         ))}
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12} md={3}>
//                       <TextField
//                         type="date"
//                         label="Start Date"
//                         fullWidth
//                         InputLabelProps={{ shrink: true }}
//                         value={c.start_date || ""}
//                         onChange={(e) =>
//                           updateClosureField(index, "start_date", e.target.value)
//                         }
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={3}>
//                       <TextField
//                         type="date"
//                         label="End Date"
//                         fullWidth
//                         InputLabelProps={{ shrink: true }}
//                         value={c.end_date || ""}
//                         onChange={(e) =>
//                           updateClosureField(index, "end_date", e.target.value)
//                         }
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <TextField
//                         label="Reason"
//                         fullWidth
//                         value={c.reason || ""}
//                         onChange={(e) =>
//                           updateClosureField(index, "reason", e.target.value)
//                         }
//                       />
//                     </Grid>

//                     <Grid
//                       item
//                       xs={12}
//                       md={2}
//                       sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                     >
//                       <Button
//                         variant="contained"
//                         size="small"
//                         onClick={() => saveClosure(c)}
//                       >
//                         {c.id ? "Update" : "Save"}
//                       </Button>

//                       <IconButton
//                         color="error"
//                         onClick={() => deleteClosure(c, index)}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Typography variant="body2" color="text.secondary">
//                         Selected:{" "}
//                         {Array.isArray(c.service_types) && c.service_types.length
//                           ? c.service_types.join(", ")
//                           : "-"}
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Card>
//               ))}
//             </>
//           )}
//         </CardContent>
//       </Card>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert
//           severity={snackbar.severity}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default RiteClientDetails;









import React, { useState, useEffect } from "react";
import {
  Box, Grid, TextField, Typography, Button, Switch, Card, CardContent,
  Snackbar, Alert, MenuItem, IconButton, FormControlLabel, Chip, Divider, Paper, Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import RoomServiceIcon from "@mui/icons-material/RoomService";

import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import { useParams } from "react-router-dom";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";
const gradientHeader = "linear-gradient(135deg, #0d47a1, #1565c0)";

const sectionCard = {
  borderRadius: "16px",
  boxShadow: "0 4px 24px rgba(13,71,161,0.07)",
  border: `1px solid ${accentLight}`,
  overflow: "hidden",
  mb: 3,
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#f8f9fb",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent },
};

const accentBtn = {
  background: gradientHeader,
  color: "#fff",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  px: 3,
  "&:hover": { background: "linear-gradient(135deg, #1565c0, #0d47a1)" },
};

const outlineBtn = {
  borderColor: accent,
  color: accent,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  "&:hover": { backgroundColor: accentLight, borderColor: accent },
};

const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const services = ["pickup", "delivery", "dine_in"];

const serviceLabel = (s) => s.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());

const SectionHeader = ({ icon, title, subtitle }) => (
  <Box sx={{ background: gradientHeader, color: "#fff", px: 3, py: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}>
    {icon}
    <Box>
      <Typography variant="h6" fontWeight={700}>{title}</Typography>
      {subtitle && <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.25 }}>{subtitle}</Typography>}
    </Box>
  </Box>
);

const RiteClientDetails = ({ client }) => {
  const token = getDecryptedAccessToken();
  const { clientId } = useParams();
  const resolvedClientId = clientId || client?.client_id;

  const [profile, setProfile] = useState(null);
  const [workingHours, setWorkingHours] = useState([]);
  const [workingHoursForm, setWorkingHoursForm] = useState([]);
  const [closures, setClosures] = useState([]);
  const [serviceTypes, setServiceTypes] = useState({ pickup: false, delivery: false, dine_in: false });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const today = new Date().toISOString().split("T")[0];
  const showSnackbar = (msg, type = "success") => setSnackbar({ open: true, message: msg, severity: type });

  const fetchProfile = async () => {
    try {
      const res = await ApiServices.get(`/api/v1/clients/${resolvedClientId}/full/`, { Authorization: `Bearer ${token}` });
      setProfile(res.data);
      setServiceTypes(res.data.service_types || { pickup: false, delivery: false, dine_in: false });
    } catch { showSnackbar("Failed loading client", "error"); }
  };

  const fetchWorkingHours = async () => {
    try {
      const res = await ApiServices.get(`/api/v1/clients/${resolvedClientId}/working-hours/`, { Authorization: `Bearer ${token}` });
      setWorkingHours(Array.isArray(res.data) ? res.data : []);
    } catch { setWorkingHours([]); showSnackbar("Failed loading working hours", "error"); }
  };

  const fetchClosures = async () => {
    try {
      const res = await ApiServices.get(`/api/v1/clients/${resolvedClientId}/service-close/`, { Authorization: `Bearer ${token}` });
      const list = Array.isArray(res.data) ? res.data : [];
      setClosures(list.map((item) => ({ ...item, local_id: item.id || Date.now() + Math.random(), isNew: false })));
    } catch { setClosures([]); showSnackbar("Failed loading closures", "error"); }
  };

  const fetchAll = async () => { await Promise.all([fetchProfile(), fetchWorkingHours(), fetchClosures()]); };

  useEffect(() => { if (resolvedClientId) fetchAll(); }, [resolvedClientId]);

  const validateDetails = () => {
    if (!profile.details?.trading_name?.trim()) return "Trading name required";
    if (!profile.details?.year_established) return "Year required";
    const year = Number(profile.details.year_established);
    if (Number.isNaN(year) || year < 1800 || year > new Date().getFullYear()) return "Enter a valid year established";
    return null;
  };

  const saveDetails = async () => {
    const error = validateDetails();
    if (error) return showSnackbar(error, "error");
    try {
      await ApiServices.patch(`/api/v1/clients/${resolvedClientId}/details/`, profile.details, { Authorization: `Bearer ${token}` });
      showSnackbar("Details saved"); fetchProfile();
    } catch { showSnackbar("Error saving details", "error"); }
  };

  const saveServiceTypes = async () => {
    try {
      await ApiServices.post(`/api/v1/clients/${resolvedClientId}/service-types/`, serviceTypes, { Authorization: `Bearer ${token}` });
      showSnackbar("Service types updated"); fetchProfile();
    } catch { showSnackbar("Error updating service types", "error"); }
  };

  const addWorkingHourRow = () => {
    setWorkingHoursForm((prev) => [...prev, { local_id: Date.now() + Math.random(), service_type: "", day: "", open_time: "", close_time: "", break_start: "", break_end: "" }]);
  };

  const updateWorkingHourRow = (index, field, value) => {
    setWorkingHoursForm((prev) => { const u = [...prev]; u[index] = { ...u[index], [field]: value }; return u; });
  };

  const removeWorkingHourRow = (index) => setWorkingHoursForm((prev) => prev.filter((_, i) => i !== index));

  const validateWorkingHours = () => {
    if (!workingHoursForm.length) return "Add at least one working hours row";
    for (let i = 0; i < workingHoursForm.length; i++) {
      const row = workingHoursForm[i]; const n = i + 1;
      if (!row.service_type) return `Select service type for row ${n}`;
      if (!services.includes(row.service_type)) return `Invalid service type in row ${n}`;
      if (!row.day) return `Select day for row ${n}`;
      if (!days.includes(row.day)) return `Invalid day in row ${n}`;
      if (!row.open_time) return `Open time required in row ${n}`;
      if (!row.close_time) return `Close time required in row ${n}`;
      if (row.open_time >= row.close_time) return `Close time must be after open time in row ${n}`;
      if (row.break_start && !row.break_end) return `Break end required in row ${n}`;
      if (!row.break_start && row.break_end) return `Break start required in row ${n}`;
      if (row.break_start && row.break_end) {
        if (!(row.break_start > row.open_time && row.break_end < row.close_time)) return `Break time must be within open and close time in row ${n}`;
        if (row.break_start >= row.break_end) return `Break end must be after break start in row ${n}`;
      }
    }
    return null;
  };

  const buildWorkingHoursPayload = () => {
    const grouped = {};
    workingHoursForm.forEach((row) => {
      if (!grouped[row.service_type]) grouped[row.service_type] = [];
      grouped[row.service_type].push({ day: row.day, open_time: row.open_time, close_time: row.close_time, ...(row.break_start ? { break_start: row.break_start } : {}), ...(row.break_end ? { break_end: row.break_end } : {}) });
    });
    return { working_hours: Object.keys(grouped).map((st) => ({ service_type: st, schedule: grouped[st] })) };
  };

  const saveWorkingHours = async () => {
    const error = validateWorkingHours();
    if (error) return showSnackbar(error, "error");
    try {
      await ApiServices.post(`/api/v1/clients/${resolvedClientId}/working-hours/`, buildWorkingHoursPayload(), { Authorization: `Bearer ${token}` });
      showSnackbar("Working hours saved"); setWorkingHoursForm([]); fetchWorkingHours();
    } catch { showSnackbar("Error saving working hours", "error"); }
  };

  const addClosureRow = () => {
    setClosures((prev) => [{ local_id: Date.now() + Math.random(), id: null, service_types: ["all"], start_date: today, end_date: today, reason: "", isNew: true }, ...prev]);
  };

  const updateClosureField = (index, field, value) => {
    setClosures((prev) => { const u = [...prev]; u[index] = { ...u[index], [field]: value }; return u; });
  };

  const handleClosureServiceTypeToggle = (index, value) => {
    setClosures((prev) => {
      const u = [...prev]; const c = u[index];
      let ct = Array.isArray(c.service_types) ? [...c.service_types] : [];
      if (value === "all") { ct = ["all"]; } else {
        ct = ct.filter((i) => i !== "all");
        ct = ct.includes(value) ? ct.filter((i) => i !== value) : [...ct, value];
        if (!ct.length) ct = ["all"];
      }
      u[index] = { ...c, service_types: ct }; return u;
    });
  };

  const validateClosure = (closure) => {
    if (!closure.start_date) return "Closure start date required";
    if (!closure.end_date) return "Closure end date required";
    if (closure.end_date < closure.start_date) return "Closure end date cannot be before start date";
    if (!Array.isArray(closure.service_types) || closure.service_types.length === 0) return "Select at least one closure service type";
    return null;
  };

  const saveClosure = async (closure) => {
    const error = validateClosure(closure);
    if (error) return showSnackbar(error, "error");
    const payload = { service_types: closure.service_types, start_date: closure.start_date, end_date: closure.end_date, reason: closure.reason || "" };
    try {
      if (closure.id) {
        await ApiServices.patch(`/api/v1/clients/service-close/${closure.id}/`, payload, { Authorization: `Bearer ${token}` });
        showSnackbar("Closure updated");
      } else {
        await ApiServices.post(`/api/v1/clients/${resolvedClientId}/service-close/`, payload, { Authorization: `Bearer ${token}` });
        showSnackbar("Closure created");
      }
      fetchClosures();
    } catch { showSnackbar("Error saving closure", "error"); }
  };

  const deleteClosure = async (closure, index) => {
    try {
      if (!closure.id) { setClosures((prev) => prev.filter((_, i) => i !== index)); showSnackbar("Unsaved closure removed"); return; }
      await ApiServices.delete(`/api/v1/clients/service-close/${closure.id}/`, { Authorization: `Bearer ${token}` });
      showSnackbar("Closure deleted"); fetchClosures();
    } catch { showSnackbar("Error deleting closure", "error"); }
  };

  if (!profile) return null;

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>

      {/* ─── CLIENT DETAILS ─── */}
      <Card sx={sectionCard}>
        <SectionHeader icon={<StorefrontIcon />} title="Client Details" subtitle="Update your restaurant's basic information" />
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={6}>
              <TextField label="Trading Name" fullWidth sx={inputSx} value={profile.details?.trading_name || ""}
                onChange={(e) => setProfile({ ...profile, details: { ...profile.details, trading_name: e.target.value } })} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Tagline" fullWidth sx={inputSx} value={profile.details?.tagline || ""}
                onChange={(e) => setProfile({ ...profile, details: { ...profile.details, tagline: e.target.value } })} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="About" multiline rows={3} fullWidth sx={inputSx} value={profile.details?.about_us || ""}
                onChange={(e) => setProfile({ ...profile, details: { ...profile.details, about_us: e.target.value } })} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField label="Year Established" type="number" fullWidth sx={inputSx} value={profile.details?.year_established || ""}
                onChange={(e) => setProfile({ ...profile, details: { ...profile.details, year_established: e.target.value } })} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField label="Category ID" fullWidth sx={inputSx} value={profile.details?.category_id || ""}
                onChange={(e) => setProfile({ ...profile, details: { ...profile.details, category_id: e.target.value } })} />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={saveDetails} sx={accentBtn}>Save Details</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* ─── SERVICE TYPES ─── */}
      <Card sx={sectionCard}>
        <SectionHeader icon={<RoomServiceIcon />} title="Service Types" subtitle="Enable or disable the services you offer" />
        <CardContent sx={{ p: 3 }}>
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
            {services.map((s) => (
              <Paper key={s} variant="outlined" sx={{
                px: 2.5, py: 1.5, borderRadius: "12px", display: "flex", alignItems: "center", gap: 1,
                border: serviceTypes[s] ? `2px solid ${accent}` : "1px solid #e0e0e0",
                backgroundColor: serviceTypes[s] ? accentLight : "#fff",
                transition: "all 0.2s",
              }}>
                <FormControlLabel
                  control={<Switch checked={!!serviceTypes[s]} onChange={(e) => setServiceTypes({ ...serviceTypes, [s]: e.target.checked })}
                    sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: accent }, "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: accent } }} />}
                  label={<Typography fontWeight={600} fontSize={14}>{serviceLabel(s)}</Typography>}
                />
              </Paper>
            ))}
          </Stack>
          <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={saveServiceTypes} sx={accentBtn}>Save Services</Button>
        </CardContent>
      </Card>

      {/* ─── WORKING HOURS ─── */}
      <Card sx={sectionCard}>
        <SectionHeader icon={<AccessTimeIcon />} title="Working Hours" subtitle="Configure operating hours per service type and day" />
        <CardContent sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add rows below — they'll be grouped by service type and saved together.
          </Typography>

          <Button variant="outlined" startIcon={<AddCircleOutlineIcon />} onClick={addWorkingHourRow} sx={{ ...outlineBtn, mb: 2 }}>
            Add Working Hour Row
          </Button>

          {workingHoursForm.map((row, index) => (
            <Paper key={row.local_id} variant="outlined" sx={{ p: 2, mb: 2, borderRadius: "12px", backgroundColor: accentLight, border: `1px solid ${accent}20` }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={2}>
                  <TextField select label="Service Type" fullWidth sx={inputSx} value={row.service_type}
                    onChange={(e) => updateWorkingHourRow(index, "service_type", e.target.value)}>
                    {services.map((s) => <MenuItem key={s} value={s}>{serviceLabel(s)}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField select label="Day" fullWidth sx={inputSx} value={row.day}
                    onChange={(e) => updateWorkingHourRow(index, "day", e.target.value)}>
                    {days.map((d) => <MenuItem key={d} value={d} sx={{ textTransform: "capitalize" }}>{d}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={6} md={1.5}>
                  <TextField type="time" label="Open" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                    value={row.open_time} onChange={(e) => updateWorkingHourRow(index, "open_time", e.target.value)} />
                </Grid>
                <Grid item xs={6} md={1.5}>
                  <TextField type="time" label="Close" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                    value={row.close_time} onChange={(e) => updateWorkingHourRow(index, "close_time", e.target.value)} />
                </Grid>
                <Grid item xs={6} md={1.5}>
                  <TextField type="time" label="Break Start" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                    value={row.break_start} onChange={(e) => updateWorkingHourRow(index, "break_start", e.target.value)} />
                </Grid>
                <Grid item xs={6} md={1.5}>
                  <TextField type="time" label="Break End" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                    value={row.break_end} onChange={(e) => updateWorkingHourRow(index, "break_end", e.target.value)} />
                </Grid>
                <Grid item xs={12} md={1}>
                  <IconButton onClick={() => removeWorkingHourRow(index)} sx={{ color: "#d32f2f", backgroundColor: "#ffebee", "&:hover": { backgroundColor: "#ffcdd2" } }}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Paper>
          ))}

          <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={saveWorkingHours} sx={{ ...accentBtn, mt: 1 }}>
            Save Working Hours
          </Button>

          <Divider sx={{ my: 3, borderColor: `${accent}15` }} />

          <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, color: accent }}>Existing Working Hours</Typography>

          {!workingHours.length ? (
            <Paper variant="outlined" sx={{ p: 4, textAlign: "center", borderRadius: "12px", borderStyle: "dashed", borderColor: `${accent}30` }}>
              <AccessTimeIcon sx={{ fontSize: 40, color: `${accent}40`, mb: 1 }} />
              <Typography color="text.secondary">No working hours configured yet.</Typography>
            </Paper>
          ) : (
            <Grid container spacing={2} marginBottom={5}>
              {workingHours.map((item) => (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  <Paper variant="outlined" sx={{ p: 2, borderRadius: "12px", border: `1px solid ${accentLight}`, height: "100%", transition: "all 0.2s", "&:hover": { boxShadow: "0 4px 16px rgba(13,71,161,0.1)" } }}>
                    <Chip label={serviceLabel(item.service_type)} size="small" sx={{ backgroundColor: accentLight, color: accent, fontWeight: 600, mb: 1.5 }} />
                    <Typography variant="body2" sx={{ textTransform: "capitalize", fontWeight: 600, mb: 0.5 }}>{item.day}</Typography>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">Open</Typography>
                        <Typography variant="body2" fontWeight={600}>{item.open_time}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="text.secondary">Close</Typography>
                        <Typography variant="body2" fontWeight={600}>{item.close_time}</Typography>
                      </Box>
                    </Stack>
                    {(item.break_start || item.break_end) && (
                      <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Break Start</Typography>
                          <Typography variant="body2">{item.break_start || "-"}</Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Break End</Typography>
                          <Typography variant="body2">{item.break_end || "-"}</Typography>
                        </Box>
                      </Stack>
                    )}
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </CardContent>
      </Card>

      {/* ─── SERVICE CLOSURES ─── */}
      <Card sx={sectionCard}>
        <Box sx={{ background: gradientHeader, color: "#fff", px: 3, py: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <EventBusyIcon />
            <Box>
              <Typography variant="h6" fontWeight={700}>Service Closures</Typography>
              <Typography variant="body2" sx={{ opacity: 0.85 }}>Schedule temporary closures for holidays or maintenance</Typography>
            </Box>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={fetchClosures}
              sx={{ borderColor: "rgba(255,255,255,0.5)", color: "#fff", borderRadius: "10px", textTransform: "none", "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}>
              Refresh
            </Button>
            <Button variant="contained" startIcon={<AddCircleOutlineIcon />} onClick={addClosureRow}
              sx={{ backgroundColor: "#fff", color: accent, borderRadius: "10px", textTransform: "none", fontWeight: 600, "&:hover": { backgroundColor: accentLight } }}>
              Add Closure
            </Button>
          </Stack>
        </Box>

        <CardContent sx={{ p: 3 }}>
          {!closures.length ? (
            <Paper variant="outlined" sx={{ p: 4, textAlign: "center", borderRadius: "12px", borderStyle: "dashed", borderColor: `${accent}30` }}>
              <EventBusyIcon sx={{ fontSize: 40, color: `${accent}40`, mb: 1 }} />
              <Typography color="text.secondary">No closures scheduled.</Typography>
              <Button variant="outlined" startIcon={<AddCircleOutlineIcon />} onClick={addClosureRow} sx={{ ...outlineBtn, mt: 2 }}>
                Add Your First Closure
              </Button>
            </Paper>
          ) : (
            <Stack spacing={2}>
              {closures.map((c, index) => (
                <Paper key={c.id || c.local_id} variant="outlined" sx={{
                  p: 2.5, borderRadius: "12px", transition: "all 0.2s",
                  border: c.isNew ? `2px dashed ${accent}` : `1px solid ${accentLight}`,
                  backgroundColor: c.isNew ? `${accentLight}80` : "#fff",
                  "&:hover": { boxShadow: "0 4px 16px rgba(13,71,161,0.08)" },
                }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Chip label={c.id ? `#${c.id}` : "New"} size="small"
                        sx={{ backgroundColor: c.isNew ? accent : accentLight, color: c.isNew ? "#fff" : accent, fontWeight: 700 }} />
                      <Typography variant="body2" color="text.secondary">
                        {c.start_date || "—"} → {c.end_date || "—"}
                      </Typography>
                    </Stack>
                    <IconButton size="small" onClick={() => deleteClosure(c, index)}
                      sx={{ color: "#d32f2f", backgroundColor: "#ffebee", "&:hover": { backgroundColor: "#ffcdd2" } }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>

                  <Typography variant="subtitle2" sx={{ mb: 1, color: accent }}>Affected Services</Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
                    <Chip label="All" size="small" onClick={() => handleClosureServiceTypeToggle(index, "all")}
                      sx={{ cursor: "pointer", fontWeight: 600, backgroundColor: c.service_types?.includes("all") ? accent : "#f5f5f5", color: c.service_types?.includes("all") ? "#fff" : "#666" }} />
                    {services.map((s) => (
                      <Chip key={s} label={serviceLabel(s)} size="small" onClick={() => handleClosureServiceTypeToggle(index, s)}
                        sx={{ cursor: "pointer", fontWeight: 600, backgroundColor: c.service_types?.includes(s) ? accent : "#f5f5f5", color: c.service_types?.includes(s) ? "#fff" : "#666" }} />
                    ))}
                  </Stack>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={3}>
                      <TextField type="date" label="Start Date" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                        value={c.start_date || ""} onChange={(e) => updateClosureField(index, "start_date", e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField type="date" label="End Date" fullWidth InputLabelProps={{ shrink: true }} sx={inputSx}
                        value={c.end_date || ""} onChange={(e) => updateClosureField(index, "end_date", e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField label="Reason (optional)" fullWidth sx={inputSx}
                        value={c.reason || ""} onChange={(e) => updateClosureField(index, "reason", e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button variant="contained" fullWidth startIcon={<SaveOutlinedIcon />} onClick={() => saveClosure(c)} sx={accentBtn}>
                        {c.id ? "Update" : "Save"}
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </Stack>
          )}
        </CardContent>
      </Card>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity={snackbar.severity} variant="filled" onClose={() => setSnackbar({ ...snackbar, open: false })} sx={{ borderRadius: "10px" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RiteClientDetails;
